import React from 'react'
import { BANKING_BOTTOM_CONTENT, CERTIFICATION_COURSE_PAGE_4, CERTIFICATION_DETAILS_PAGE_4, CERTIFICATION_HERO_PAGE_4 } from '../../../utils/constants'
import CourseAsideHero from '../../../reusable/CourseAsideHero'
import CoursesAside from '../../../reusable/Aside-courses'
import CourseCard from '../../../reusable/Course-card'
import Accordian from '../../../reusable/Accordian'
import PageDesc from '../../../reusable/PageDesc'
import { CERTIFICATION_ACCORDIAN_4 } from '../../../utils/courseConifg'

const CertificationPage_4 = () => {
  return (
    <div className='outlet-render'>
    <CourseAsideHero  {...CERTIFICATION_HERO_PAGE_4}/>
     <CoursesAside {...CERTIFICATION_COURSE_PAGE_4}/>
     <CourseCard {...CERTIFICATION_DETAILS_PAGE_4}/>
     <Accordian {...CERTIFICATION_ACCORDIAN_4}/>
     <PageDesc {...BANKING_BOTTOM_CONTENT}/>
   </div>
  )
}

export default CertificationPage_4